import React from 'react';
import { AuthTypeRedirectButton } from './AuthTypeRedirectButton';
import { AuthTypeButtons } from './AuthTypeFormItems';
export var AuthTypeStep = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "bg-ghost-white p-4 grid grid-cols-[1fr_1fr] gap-y-7" },
            React.createElement("p", { className: "text-header-sm col-span-2 pr-5.5 font-semibold" }, "Welcome to community space."),
            React.createElement("p", { className: "font-semibold" }, "Powered by TAP")),
        React.createElement("div", { className: "py-6 px-4" },
            React.createElement(AuthTypeRedirectButton, { containerStyle: "pb-6" }),
            React.createElement(AuthTypeButtons, null))));
};
